module.exports = __webpack_public_path__ + "static-portal/img/jr06.8c1e996.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jr06.jpg
// module id = aCry
// module chunks = 4